export default __webpack_public_path__ + "static/media/transpaletaCBY.3a1e20fb.png";